const swup = new Swup({
  animateHistoryBrowsing: true,
  containers: [
    "main"
  ],
  linkSelector:
    'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup])',
  plugins: [
    new SwupA11yPlugin(),
    new SwupMetaTagsPlugin(),
    new SwupBodyClassPlugin(),
    new SwupPreloadPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: false
    })
  ]
});

document.addEventListener('swup:contentReplaced', (event) => {
  const news_section_nav__items = document.querySelectorAll('.news_sections a');
  if( typeof(news_section_nav__items) != 'undefined' && news_section_nav__items != null ) {
    news_section_nav__items.forEach( element => {
      if( element.getAttribute('href') + '/' == window.location.pathname ) {
        element.classList.add('active')
      } else if( element.classList.contains('active') ) {
        element.classList.remove('active');
      }
    });
  }
  scroll_trackers();
  sections_in_view();
});

document.addEventListener('swup:transitionEnd', (event) => {
  sticky_header();
});
